// Minimal semver comparison for the What's-New version gate — byte-for-byte the
// backend's lib/semver.ts (the two sides must agree on ordering). Plain
// major.minor.patch; a malformed part compares as 0 rather than throwing.

export function semverParts(v: string | null | undefined): [number, number, number] {
  const parts = String(v ?? '').split('.');
  const n = (i: number): number => {
    const p = Number.parseInt(parts[i] ?? '0', 10);
    return Number.isFinite(p) && p >= 0 ? p : 0;
  };
  return [n(0), n(1), n(2)];
}

/** a > b in major.minor.patch order. */
export function semverGt(a: string | null | undefined, b: string | null | undefined): boolean {
  const pa = semverParts(a);
  const pb = semverParts(b);
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] > pb[i];
  }
  return false;
}
